import { userReducer, UserState } from '../User'
import { calculReducer } from './../Calculs/CalculsReducer'
import { appReducer, AppReducerState } from './AppReducer'
/* PROJECTS */

import { globalReducer, GlobalState } from '../Global'
import { CalculState } from '../Calculs/CalculsState'
import { subscriptionReducer } from '../subscription'
import { adsReducer, AdsState } from '../ads'
import { SubscriptionState } from '@batical/types/src'
import { NavigationState, navigationReducer } from '../navigation'
import { StripeState } from '../Stripe'
import { stripeReducer } from '../Stripe/StripeReducer'
import { MailProfileState } from '../MailProfile'
import { mailProfileReducer } from '../MailProfile/MailProfileReducer'
import projectCustomReducer, { ProjectCustomState } from '../Projects/ProjectCustomReducer'

export type ReduxState = {
  calcul: CalculState
  subscription: SubscriptionState
  app: AppReducerState
  user: UserState
  global: GlobalState
  ads: AdsState
  calculNav: NavigationState
  stripe: StripeState
  mailProfile: MailProfileState
  projectCustom: ProjectCustomState
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reducers: any = {
  calcul: calculReducer,
  global: globalReducer,
  subscription: subscriptionReducer,
  app: appReducer,
  user: userReducer,
  ads: adsReducer,
  calculNav: navigationReducer,
  stripe: stripeReducer,
  mailProfile: mailProfileReducer,
  projectCustom: projectCustomReducer
}

export default reducers

export type Reducers = typeof reducers
